import { GridLayoutElement } from 'adapter/in/dashboards/components/generic/ReactGrid';
import {
    NEW_WIDGET_MIN_HEIGHT,
    NEW_WIDGET_MIN_WIDTH,
    WidgetCoordinates,
} from 'adapter/in/dashboards/components/Grid/newWidgetOverlayUtils';
import { COLUMNS } from 'adapter/in/dashboards/components/Grid/constants';
import { LayoutElementType, LayoutType } from 'domain/entity/layout';

export const LOCAL_BUSINESS_INSIGHT_ID_PREFIX = '__local_business_insight__';

export const createLocalBusinessInsightId = (): string =>
    `${LOCAL_BUSINESS_INSIGHT_ID_PREFIX}${Date.now()}_${Math.random().toString(36).slice(2)}`;

export const isLocalBusinessInsightId = (id?: string | null): boolean => !!id?.startsWith(LOCAL_BUSINESS_INSIGHT_ID_PREFIX);

export const createLocalBusinessInsightGridElement = (
    coordinates: WidgetCoordinates,
    businessInsightType: string
): GridLayoutElement => createBusinessInsightGridElement(coordinates, createLocalBusinessInsightId(), businessInsightType);

export const createBusinessInsightGridElement = (
    coordinates: WidgetCoordinates,
    businessInsightId: string,
    businessInsightType?: string
): GridLayoutElement => ({
    i: businessInsightId,
    x: coordinates.x,
    y: coordinates.y,
    w: coordinates.w,
    h: coordinates.h,
    static: false,
    type: LayoutElementType.BUSINESS_INSIGHT,
    businessInsightType,
    minWidth: NEW_WIDGET_MIN_WIDTH,
    maxWidth: COLUMNS[LayoutType.A4],
    minHeight: NEW_WIDGET_MIN_HEIGHT,
    maxHeight: COLUMNS[LayoutType.A4],
});
